import React from 'react';
import * as LinkToBookChatSelector from '../../data/LinkToBookChatSelector';
import LinkToBookchat from 'react/views/generic/LinkToBookchat';
import BookChatEventTypes from 'data/types/LinkToBookChatEventTypes';

const LinkToBookChatContainer = (props) => {
	const chatLink = LinkToBookChatSelector.getLinkToBookChatInfo();
    if (chatLink){
        return (
            <LinkToBookchat
                href={chatLink.link}
                featureType={BookChatEventTypes.BOOKCHAT_LINK_CLICKED}
                srcId={chatLink.srcId}
                destId={chatLink.destId}
            />
        );
    }else {
        return null;
    }
}

export default LinkToBookChatContainer;



// WEBPACK FOOTER //
// ./src/react/containers/LinkToBookChatContainer.jsx